var alignment_rtlignore_default = {
  "alignLeft": "E4duE",
  "textWrapNowrap": "YjsdJ",
  "alignRight": "JEWI5",
  "alignCenter": "aiAP0",
  "sizeFullWidth": "xVYYk",
  "renderedInTable": "_6tVk8",
  "sizeOriginal": "_4c-9b",
  "sizeContent": "a1dU1",
  "sizeSmall": "Nsf6v",
  "sizeSmallCenter": "utco6",
  "flex": "os4-L",
  "LEFT": "wGvE1",
  "CENTER": "XCNbA",
  "RIGHT": "mHbhE",
  "AUTO": "_6XZJW",
  "JUSTIFY": "_3GmD8"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
